<template>
    <div>
        <div class="row mt-5">
            <div class="col-sm-4 modspec_font14-600">Name this construction</div>
            <div class="col-sm-8">
                <input type="text" class="form-control" placeholder="i.e “Construction option A”..." v-model="construction.Name" />
            </div>
        </div>
    </div>


    <roof />

    <ceiling />

    <wall />

    <glazing />

    <floor />

    <div class="row mt-5">
        <div class="col-sm-12">
            <button class="btn btn-primary w-100" @click="saveAll">Save Construction</button>
        </div>
    </div>

    <div class="row mt-2">
        <div class="col-sm-12">
            <router-link class="btn btn-primary w-100" :to="{name:'ScopingTool'}">Cancel</router-link>
        </div>
    </div>

    <div class="row mt-5">
    </div>

</template>

<script>
import roof from "../../components/quote/cd-roof.vue";
import ceiling from "../../components/quote/cd-ceiling.vue";
import wall from "../../components/quote/cd-wall.vue";
import glazing from "../../components/quote/cd-glazing.vue";
import floor from "../../components/quote/cd-floor.vue";
export default {
    name: "new-construction",
    props: ["idCliente"],
    components: {
        'roof': roof,
        'ceiling': ceiling,
        'wall': wall,
        'glazing': glazing,
        'floor': floor,
    },

    data: function () {
        return {
            idClient: 0,
            construction:{Name:''}
        }
    },
    methods: {
        saveAll() { },
    }
}
</script>

<style></style>